import { createSlice } from '@reduxjs/toolkit'
import { BASE_MEDIA_QUERY } from '../static/config'

export const sidenavInitialState = () => {
  return BASE_MEDIA_QUERY.matches
}

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    sidenavOpened: sidenavInitialState(),
    topbarOpened: !sidenavInitialState(),
    isGoogleMapsReady: false
  },
  reducers: {
    toggleSidenav (state, action) {
      state.sidenavOpened = action.payload
    },
    setGoogleMapsReady (state, action) {
      state.isGoogleMapsReady = action.payload
    }
  }
})

export default uiSlice.reducer
export const uiActions = uiSlice.actions
